import { ref } from 'vue';
import config from '@/config';

const isScriptLoaded = ref(false);
const isScriptLoading = ref(false);

export function useGoogleMaps() {
  const loadScript = () => {
    return new Promise((resolve, reject) => {
      if (isScriptLoaded.value) {
        resolve();
        return;
      }
      if (isScriptLoading.value) {
        // If script is already loading, wait for it to finish
        const interval = setInterval(() => {
          if (isScriptLoaded.value) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
        return;
      }

      isScriptLoading.value = true;
      const apiKey = config.googleMaps.apiKey;
      if (!apiKey) {
        console.error('Google Maps API key not configured');
        reject(new Error('Google Maps API key not configured'));
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        isScriptLoading.value = false;
        isScriptLoaded.value = true;
        resolve();
      };
      script.onerror = () => {
        isScriptLoading.value = false;
        reject(new Error('Failed to load Google Maps script.'));
      };
      document.head.appendChild(script);
    });
  };

  return { loadScript, isScriptLoaded };
}